import axios from "axios";
import { clearClientAuth } from "./action";
import { getStoredAuthToken } from "./authToken";

export async function checkAutoLogin(dispatch) {
    const token = getStoredAuthToken();
    if (!token) {
        clearClientAuth(dispatch);
        return;
    } else {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        try {
            const businessResponse = await axios.get(`v1/business/current`);
            dispatch({ type: "BUSINESS_RES", payload: businessResponse });
            axios.defaults.headers.common["x-business-id"] = businessResponse.data._id;

            axios
                .get(`/v1/business/${businessResponse.data._id}`)
                .then((res) => {
                    dispatch({ type: "BUSINESSES_RES", payload: res });
                })
                .catch((error) => {
                    console.log(error);
                });

            const profileResponse = await axios.get("v1/users/profile");
            dispatch({ type: "USER_PROFILE", payload: profileResponse });
        } catch (error) {
            if (error?.response?.status === 401) {
                clearClientAuth(dispatch);
            }
            console.log(error);
        }
    }
}
